module.exports = __webpack_public_path__ + "assets/img/title-d43e2f56.png";